import { motion } from 'framer-motion';

const shapes = [
  { type: 'triangle', color: '#ef4444', x: 10, y: 20, size: 40, delay: 0 },
  { type: 'triangle', color: '#f59e0b', x: 85, y: 15, size: 35, delay: 0.5 },
  { type: 'square', color: '#22c55e', x: 5, y: 70, size: 30, delay: 1 },
  { type: 'triangle', color: '#3b82f6', x: 90, y: 60, size: 45, delay: 1.5 },
  { type: 'square', color: '#8b5cf6', x: 15, y: 45, size: 25, delay: 2 },
  { type: 'triangle', color: '#ec4899', x: 80, y: 80, size: 38, delay: 2.5 },
  { type: 'square', color: '#06b6d4', x: 50, y: 10, size: 28, delay: 3 },
  { type: 'triangle', color: '#eab308', x: 70, y: 35, size: 32, delay: 3.5 },
];

export default function GeometricShapes() {
  return (
    <div className="absolute inset-0 w-full h-full overflow-hidden pointer-events-none">
      {shapes.map((shape, index) => (
        <motion.div
          key={index}
          className="absolute"
          style={{
            left: `calc(${shape.x}% - ${shape.size / 2}px)`,
            top: `calc(${shape.y}% - ${shape.size / 2}px)`,
          }}
          initial={{ opacity: 0.1, scale: 0.8, rotate: 0 }}
          animate={{
            opacity: [0.1, 0.3, 0.1],
            scale: [0.8, 1, 0.8],
            rotate: [0, 180, 360],
          }}
          transition={{
            duration: 12,
            delay: shape.delay,
            repeat: Infinity,
            ease: 'easeInOut',
          }}
        >
          {shape.type === 'triangle' ? (
            <div
              style={{
                width: 0,
                height: 0,
                borderLeft: `${shape.size / 2}px solid transparent`,
                borderRight: `${shape.size / 2}px solid transparent`,
                borderBottom: `${shape.size}px solid ${shape.color}`,
                opacity: 0.4,
                filter: `drop-shadow(0 0 10px ${shape.color})`,
              }}
            />
          ) : (
            <div
              style={{
                width: shape.size,
                height: shape.size,
                backgroundColor: shape.color,
                opacity: 0.3,
                filter: `drop-shadow(0 0 10px ${shape.color})`,
                transform: 'rotate(45deg)',
              }}
            />
          )}
        </motion.div>
      ))}
    </div>
  );
}

